export default __webpack_public_path__ + "826b666636171064de69a43a47fe7936.png";